import React, {useState,useEffect,useMemo} from 'react';

import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import {fetchReportColumnsLibrary, fetchReportColumns, updateReportColumns, deleteReportColumn} from '../Redux/Reports/ReportsActions'
import { Alert, Snackbar } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

function ReportColumns() {
  // store data access start
const reports = useSelector(state =>state.Reports)
// store data access End
  const dispatch = useDispatch()  // for accessing the redux function

  // component all states define start
  const [reportColumnsResult,setReportColumnsResult] = useState([]);
  const [open, setOpen] = useState(false);
  const [remove, setRemove] = useState(false);
  const [error, setError] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');

  // component all states define End

  // const [inputValues,setInputValues] = useState([{
  //               columnName:"",
  //               columnVariable:"",
  //               type:"",
  //               formula:""
  //   }]);

   const [inputValues, setInputValues] = useState(reportColumnsResult || []);

  const [inputCode,setInputCode] = useState({
                codeName:""
    });  

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(inputValues);
    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);
    setInputValues(items);
  };

   //hooks start
   // fetch allexams api hook start
   useEffect(() =>{
     dispatch(fetchReportColumnsLibrary())
     dispatch(fetchReportColumns())
   },[dispatch])
// fetch allexams api hook End

// add data of allexams api into constant,hook start
  //  useMemo(() =>{
  //    if(reports && reports.report_columns && reports.report_columns.data && reports.report_columns.request_status === true){
  //      setReportColumnsResult(reports.report_columns.data)
  //    }
  //  },[reports])


useEffect(() => {
  if (
    reports &&
    reports.report_columns &&
    reports.report_columns.data &&
    reports.report_columns.request_status === true
  ) {
    setReportColumnsResult(reports.report_columns.data);
    setInputValues(reports.report_columns.data);
  }
}, [reports]);

useEffect(() => {
  if (
    reports &&
    reports.delete_report_column &&
    reports.delete_report_column.object &&
    reports.delete_report_column.request_status === true
  ) {
    const updated = inputValues.filter(item => item.id !== reports.columnId);
    setInputValues(updated);
    
    setOpen(true);
    setError(false);
    setRemove(true);
  }
}, [reports]);

useEffect(() => {
  if (
    reports &&
    reports.update_report_columns &&
    reports.update_report_columns.object &&
    reports.update_report_columns.request_status === true
  ) {
    setOpen(true);
    setError(false);
    setRemove(false);
  }
}, [reports]);

useEffect(() => {
  if (
    reports.report_columns_error && reports.report_columns_error.object && reports.report_columns_error.object.error
  ) {
     setOpen(true);
     setError(true);
     setRemove(false);
  }
}, [reports]);
// add data of allexams api into constant,hook End
   //hooks end

  const handleChange = (index, field, value) => {
    const updatedColumns = [...inputValues];
    updatedColumns[index][field] = value;
    setInputValues(updatedColumns);
    if(field == 'type') setSelectedValue(value);
 };

 const handleSave = () => {
  //console.log("Updated Values:", inputValues);
  dispatch(updateReportColumns(inputValues,inputCode.codeName));
  var len = inputValues.length - 1;
  if(null == inputValues[len].id) {
    setTimeout(() => {
      dispatch(fetchReportColumns());
    }, 1500);
  }
};

const handleAddRow = () => {
  const newRow = {
    columnName: "",
    columnVariable: "",
    type: "",
    formula: "",
    shouldShow: false
  };

  const updatedColumns = [...inputValues, newRow];

  setInputValues(updatedColumns);
};

const [isChecked, setIsChecked] = useState(false);

  const handleChang = (e) => {
    setIsChecked(e.target.checked);
  };

const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };


  const handledelete = (e) => {
     dispatch(deleteReportColumn(inputCode.codeName, e));     
  }

   return (
               <>
               <div className="breadcrumbs-area">
                 <h3>Report Columns</h3>
                 <ul>
                   <li>
                     <Link to="/">Home</Link>
                   </li>
                   <li>Report Columns</li>
                 </ul>
               </div>
               {/* Breadcubs Area End Here */}
               {/* Exam Schedule Area Start Here */}
               <div className="row">
                 <div className="col-8-xxxl col-12">
            <div className="card">
                <div className="card-body">

                  <div className="table-box-wrap">

                      <div className="row gutters-8">



                        <div className="col-lg-4 form-group">

                        </div>
                      </div>

                    

                      {reports && reports.report_columns_loading === true ?
                        (<div className="card-body">
                        <div className="Student-Loader">
                        <Loader
                        className = "student-detail-loader"
                      type="ThreeDots"
                      color="#fea801"
                      height={150}
                      width={150}

         />
                        </div>
                      </div>) : (<div>

                    {/* <table className="table data-table text-nowrap">
                        
                        <tbody> */}

                             <div className="row align-items-center mt-3 heading-layout1 bg-darkblue">
                                <div className="col-2">
                                  <label className='text-light'>Column Name *</label>
                                </div>

                                <div className="col-2">
                                   <label className='text-light'>Column Variable*</label>
                                </div>

                                <div className="col-2">
                                   <label className='text-light'>Column Type *</label>
                                </div>

                                <div className="col-2">
                                   <label className='text-light'>Formula *</label>
                                </div>

                                <div className="col-2">
                                   <label className='text-light'>Is Show</label>
                                </div>

                                <div className="col-2">
                                   <label className='text-light'>Action</label>
                                </div>                              
                             </div>

                        <DragDropContext onDragEnd={handleDragEnd}>
  <Droppable droppableId="columns">
    {(provided) => (
      <div ref={provided.innerRef} {...provided.droppableProps}>

        {inputValues.map((item, index) => (
          <Draggable
            key={index}
            draggableId={`row-${index}`}
            index={index}
          >
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                className="row align-items-center mt-4"
              >
                <div className="col-0.5 mr-2">
                  ☰
                </div>
                <div className="col-1.5">
                  <input
                    type="text"
                    className="form-control"
                    value={item.columnName}
                    onChange={(e) =>
                      handleChange(index, "columnName", e.target.value)
                    }
                  />
                </div>

                <div className="col-2">
                  <input
                    type="text"
                    className="form-control"
                    value={item.columnVariable}
                    onChange={(e) =>
                      handleChange(index, "columnVariable", e.target.value)
                    }
                  />
                </div>

                <div className="col-2 mr-2">
                  <select value={item.type} onChange={(e) => handleChange(index, "type", e.target.value)}>
                    {reports?.report_columns_variables?.object.data_types?.map((item, i) => (
                     <option key={i} value={item}>
                     {item}
                    </option>
                   ))}
                  </select>
                </div>

                <div className="col-2">
                  <input
                    type="text"
                    className="form-control"
                    value={item.formula}
                    onChange={(e) =>
                      handleChange(index, "formula", e.target.value)
                    }
                  />
                </div>

                <div className="col-2">
                   <input
                     type="checkbox"
                     checked={item.shouldShow}
                     onChange={(e) =>
                      handleChange(index, "shouldShow", !item.shouldShow)}
                   />
                </div>

                <div className="col-0.5">
                   <button type="button" onClick={e=>handledelete(item.id)} className="btn btn-danger restdelete"><i className="fa fa-trash" aria-hidden="true"></i></button>
                </div>
              </div>
            )}
          </Draggable>
        ))}

        {provided.placeholder}
      </div>
    )}
  </Droppable>
</DragDropContext>

    <Snackbar
  open={open}
  autoHideDuration={5000}
  onClose={handleClose}
  anchorOrigin={{ vertical: "top", horizontal: "center" }}
  >
  <Alert
    onClose={handleClose}
    severity={error ? 'error' : 'success'}
    sx={{
      width: "600px",       
      fontSize: "18px",     
      padding: "16px",
    }}
  >
    {error ? (reports?.report_columns_error?.object?.error) : remove ? 'Deleted Successfully!': 'Save Successfully!'}
  </Alert>
</Snackbar>                

                      <div className="row">
                        <div className="col-4-xxxl col-lg-6 col-12 form-group">
                          <label>Update Code *</label>
                          <input
                                    type="text"
                                    className="form-control"
                                    value={inputCode.codeName}
                                    onChange={(e) =>setInputCode({...inputCode,codeName:e.target.value})}
                                    required
                                  />
                          {/* {error != null && error.timingName ? (<h6 className="addStudent-error">*{JSON.stringify(error.timingName).replace(/[\[\]"]+/g,"")}</h6>):null} */}
                         </div>
                          <div className="col-8-xxxl col-lg-6 col-12 form-group">
                              <br/>
                              <button type="button" style={{marginLeft:"10px"}} onClick={handleAddRow} className="btn-fill-lg bg-blue-dark btn-hover-yellow right-float">Add Row</button>
                              <button type="button" style={{marginLeft:"10px"}} onClick={handleSave} className="btn-fill-lg bg-blue-dark btn-hover-yellow right-float">Update</button>              
                          </div>
                       </div>

                        
                        {/* </tbody>
                      </table> */}
                    </div>)}
                  </div>
                </div>
              </div>
              </div>


              <div className="col-4-xxxl col-12">
                  <div className="card">
                    <div className="card-body">

                      <div className="heading-layout1 bg-darkblue">
                         <div className="item-title">
                           <h3 className='text-light'>Variables</h3>
                         </div>
                      </div>
                     {reports && reports.report_columns_variables && reports.report_columns_variables.request_status === true && reports.report_columns_variables.object.pre_defined_variables.map((item,index)=>{
                          return (
                          <div className="row align-items-center">
                              <label>{item}</label>
                           </div>
                           );
                        })
                       }
                    </div>
                  </div>
                </div>   

                 
                 
                 
   
               </div>
               </>
           );

}

export default ReportColumns;
